/*
 * @Descripttion: 场景价格管理
 * @Date: 2026-07-02 10:00:00
 */
import { route } from './src/router';

const name = 'scene-price-mgmt';

export { name, route };
